import React from 'react';

import { ProductDetail } from 'components/blocks/Product';

const DetailScreen = (props) => {
  return (
    <div className="page-main">
      <ProductDetail />
    </div>
  );
};

export default DetailScreen;
